(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Blinix-custom-slider"] && !Shopify.designMode) return;
  try {
    
function initBeforeAfterSlider(container) {
  const imgAfter = container.querySelector('.img-wrapper:nth-of-type(2)');
  const line = container.querySelector('#line');
  const slider = container.querySelector('#slider');

  if (slider) {
    line.style.left = `${slider.value}%`;
    imgAfter.style.clipPath = `inset(0 0 0 ${slider.value}%)`;

    slider.addEventListener('input', () => {
      line.style.left = `${slider.value}%`;
      imgAfter.style.clipPath = `inset(0 0 0 ${slider.value}%)`;
    });
  }
}

document.querySelectorAll('#slider-container').forEach(container => {
  initBeforeAfterSlider(container);
});

document.addEventListener("shopify:section:load", function(event) {
  event.target.querySelectorAll('#slider-container').forEach(container => {
    initBeforeAfterSlider(container);
  });
});

document.addEventListener("shopify:section:select", function(event) {
  event.target.querySelectorAll('#slider-container').forEach(container => {
    initBeforeAfterSlider(container);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d7-multicolumn"] && !Shopify.designMode) return;
  try {
    
  function handleChange(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        yourFunction(mutation.target.textContent);
      }
    }
  }

  const targetElement = document.querySelector('#d7-custom-slider-number');

  const observer = new MutationObserver(handleChange);

  const config = {
    characterData: true,
    childList: true,
    subtree: true
  };

  observer.observe(targetElement, config);

  let slideNumber, dots;

  function yourFunction(e) {
    slideNumber = Number(e);
    dots= document.getElementsByClassName('d7-custom-multicolumn-dots');
    for (let dot of dots) {
      dot.classList.remove("active")
    }
    dots[slideNumber - 1].classList.add("active")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer2"]) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        if (!this.elements.button) return;
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }
      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) this.hidePanel();
      }
    }
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
